<template>
  <!-- <div v-redirect-if-no-permission:REGISTERED_PASSENGERS>
        <v-tabs grow color="secondary" dark icons-and-text>
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab href="#search">
                Search
                <v-icon color="white">search</v-icon>
            </v-tab>
            <v-tab href="#unapproved" v-if="hasPermission('APPROVE_PASSENGERS')">
                Not Approved
                <v-icon color="white">fa fa-meh-o</v-icon>
            </v-tab>
            <v-tab-item value="unapproved" v-if="hasPermission('APPROVE_PASSENGERS')"> -->
  <DataTable :url="api.ACTIONS.PASSENGERS" ref="unapproved" :perPage="'100'" :enable-add="false" :enable-edit="false"
    :enable-delete="false" :formatter="formatter" :actions-extra-main="actions" :fields-hidden-main="[
      'gender',
      'whatsapp_number',
      'updated_at',
      'rejected_count',
      'account_id',
      'email',
      'profile_image',
      'wallet',
      'active',
      'deleted_at',
      'birthday',
      'id_card',
      'billing_email',
      'phone_number',
    ]" :titles="titles" />
  <!-- </v-tab-item>
            <v-tab-item value="search">
                <search provider="passengers"></search>
            </v-tab-item>
        </v-tabs>
        <confirm-passenger-dialog @approved="updateUnapprovedTable" ref="confirm_dialog"
                                  :settings.sync="confirm_dialog"></confirm-passenger-dialog>
    </div> -->
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import Search from "@/components/monaco/SearchAgent";
import ConfirmPassengerDialog from "@/components/monaco/input/ConfirmPassengerDialog";

export default {
  name: "RegisteredPassengers",
  title() {
    return this.$t("customers.passengers.title");
  },
  components: { ConfirmPassengerDialog, Search, DataTable },
  computed: {
    titles() {
      return {
        created_at: this.$t("customers.passengers.creationDate"),
        whatsapp_number: this.$t("customers.passengers.whatsapp"),
        id: "#",
        email: this.$t("customers.passengers.email"),
        username: this.$t("customers.passengers.username"),
        deleted_at: this.$t("customers.passengers.archivingDate"),
        active: this.$t("customers.passengers.wasApproved"),
        full_name: this.$t("customers.passengers.fullName"),
        id_card_front: this.$t("customers.passengers.idFront"),
        id_card_back: this.$t("customers.passengers.idBack"),
        address: this.$t("customers.passengers.address"),
        created_from_app: this.$t("customers.passengers.customerApp"),
        cardOwners: this.$t("customers.passengers.linkedAccount")
      };
    },
    actions() {
      return {
        edit: {
          title: this.$t('common.edit'),
          icon: 'edit',
          action: (item) => {
            this.$router.push({ path: `/passengers/${item.id}` });
          }
        }
      }
    },
    formatter() {
      return {
        active(val) {
          //language=HTML
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
        id_card_front: (val) => {
          return val ? this.$t("common.yes") : this.$t("common.no");
        },
        id_card_back: (val) => {
          return val ? this.$t("common.yes") : this.$t("common.no");
        },
        created_at(value) {
          return moment(value).format("DD-MM-YYYY  HH:mm");
        },
        created_from_app: (value) => {
          return value == 1 ? this.$t("common.yes") : this.$t("common.no");
        },
      };
    },
  },
  data() {
    return {
      confirm_dialog: {
        visible: false,
        passenger_id: null,
      },
    };
  },
  methods: {
    updateUnapprovedTable(id) {
      this.$refs.unapproved.removeItemFromTable((item) => item.id !== id);
    },
    params(state) {
      return new URLSearchParams(`state=${state}`);
    },
    actionsExtra(state) {
      // const moveToUnApproved = {
      //   title: "Deactivate",
      //   icon: "thumb_down",
      //   extras: {
      //     color: "red",
      //     medium: true,
      //   },
      //   action: async (item) => {
      //     try {
      //       const { data } = await this.axios.put(
      //         this.api.ACTIONS.PASSENGERS + "/" + item.id,
      //         {
      //           active: 0,
      //         }
      //       );
      //       window.getApp.$emit("SHOW_TOAST", "Moved To Unapproved", "green");
      //       this.$refs.unapproved.addItemToTable(data.data);
      //       this.$refs.approved.removeItemFromTable(item);
      //     } catch (e) {
      //       return {};
      //     }
      //   },
      // };
      // const moveToApproved = {
      //   title: "Activate",
      //   icon: "thumb_up",
      //   extras: {
      //     color: "green",
      //     medium: true,
      //   },
      //   action: async (item) => {
      //     this.confirm_dialog = {
      //       visible: true,
      //       passenger_id: item.id,
      //     };
      //   },
      // };
      const moveToArchive = {
        title: this.$t("common.delete"),
        icon: "delete",
        extras: {
          medium: true,
        },
        action: async (item) => {
          try {
            const { data } = await this.axios.delete(
              this.api.ACTIONS.PASSENGERS + "/" + item.id
            );
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.passengers.archived"), "green");
            if (item.active) this.$refs.approved.removeItemFromTable(item);
            else this.$refs.unapproved.removeItemFromTable(item);
            this.$refs.archived.addItemToTable(
              data.data
                ? data.data
                : Object.assign(item, {
                  deleted_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                })
            );
          } catch (e) {
            return {};
          }
        },
      };
      // const Unarchive = {
      //   title: "Unarchive",
      //   icon: "lock_open",
      //   extras: {
      //     color: "primary",
      //     large: true,
      //   },
      //   action: async (item) => {
      //     try {
      //       const { data } = await this.axios.delete(
      //         this.api.ACTIONS.PASSENGERS + "/" + item.id
      //       );
      //       window.getApp.$emit(
      //         "SHOW_TOAST",
      //         `Moved to ${item.active ? "Approved" : "Unapproved"}`,
      //         "green"
      //       );
      //       this.$refs.archived.removeItemFromTable(item);
      //       item = data.data;
      //       if (item.active) this.$refs.approved.addItemToTable(item);
      //       else this.$refs.unapproved.addItemToTable(item);
      //     } catch (e) {
      //       return {};
      //     }
      //   },
      // };
      const goToProfile = {
        title: this.$t("customers.passengers.goToProfile"),
        icon: "info",
        extras: {
          color: "secondary",
          large: true,
        },
        action: async (item) =>
          this.$router.push({
            name: "PassengerProfile",
            params: item,
          }),
      };
      switch (state) {
        case "unapproved":
          return { goToProfile, moveToArchive };
        case "approved":
          return { goToProfile, moveToUnApproved, moveToArchive };
        default:
          return { goToProfile, Unarchive };
      }
    },
  },
};
</script>

<style scoped></style>

<!--<v-tab href="#approved">-->
<!--Approved-->
<!--<v-icon color="white">fa fa-smile-o</v-icon>-->
<!--</v-tab>-->
<!--<v-tab href="#archived">-->
<!--Archived-->
<!--<v-icon color="white">fa fa-frown-o</v-icon>-->
<!--</v-tab>-->
<!--<v-tab-item value="approved" lazy>-->
<!--<DataTable :url="api.ACTIONS.PASSENGERS"-->
<!--ref="approved"-->
<!--:initial-url-search-params="params('approved')"-->
<!--:actions-extra-main="actionsExtra('approved')"-->
<!--:enable-edit="false"-->
<!--:enable-delete="false"-->
<!--:fields-hidden-main="['gender','first_name','last_name','profile_image','wallet','active','deleted_at','birthday','id_card']"-->
<!--:titles="titles"-->
<!--:enable-add="false"/>-->
<!--</v-tab-item>-->
<!--<v-tab-item value="archived">-->
<!--<DataTable :url="api.ACTIONS.PASSENGERS"-->
<!--ref="archived"-->
<!--:initial-url-search-params="params('archived')"-->
<!--:actions-extra-main="actionsExtra('archived')"-->
<!--:enable-edit="false"-->
<!--:titles="titles"-->
<!--:enable-delete="false"-->
<!--:formatter="formatter"-->
<!--:fields-hidden-main="['gender','first_name','last_name','profile_image','wallet','birthday','id_card']"-->
<!--:enable-add="false"/>-->
<!--</v-tab-item>-->
